import { useState } from 'react'
import { CenteredFullScreenLayout } from "@/components/layout"
import { useAuth } from '@/contexts'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { toast } from 'sonner'

export default function ForgotPasswordPage() {
  const { resetPassword } = useAuth()
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [sent, setSent] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)

    const { error } = await resetPassword(email)

    if (error) {
      toast.error(error.message)
      setIsLoading(false)
      return
    }

    setSent(true)
    setIsLoading(false)
    toast.success('Password reset link sent! Check your email.')
  }

  return (
    <CenteredFullScreenLayout>
      <div className="w-full max-w-sm mx-4 p-6 bg-card rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-center mb-6">Reset Password</h2>

        {sent ? (
          <div className="text-center space-y-4">
            <p className="text-muted-foreground">
              A password reset link has been sent to {email}. Check your inbox and click the link to choose a new password.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <Button type="submit" className="w-full" disabled={isLoading}>
              {isLoading ? 'Sending...' : 'Send Reset Link'}
            </Button>

            <div className="text-center">
              <a
                href="/signin"
                className="text-sm text-primary hover:underline"
              >
                Back to sign in
              </a>
            </div>
          </form>
        )}
      </div>
    </CenteredFullScreenLayout>
  )
}
